/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import type ModalIssueAppType from '@jira/issue__issue-view/src/IssueModal.tsx';
import { useTriggerIssueViewModal } from '@jira/issue__open-view-modal-controller/src/useTriggerIssueViewModal.tsx';
import type { Props } from '@jira/issue__issue-view/src/IssueModalProps.types.tsx';
import { IssueAppSelectorModal } from '@jira/work-item__issue-app-selector/src/IssueAppSelectorModal.tsx';
import { ModalBoundary } from '@atlassian/jira-modal/src/ui/modal-boundary/index.tsx';
import { isWorkItemModernizationGatesEnabled } from '@jira/issue__eligibility/src/isWorkItemModernizationGatesEnabled.tsx';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { ContextResult } from '@jira/platform__analytics-web-react/src/components/decorators.tsx';

export const ClassicIssueViewModal: LazyComponent<
	ContextResult<
		({
			renderFeedback,
			viewModeOptions,
			onClose,
			renderTopBanner,
			onIssueDeleteSuccess,
			onIssueDeleteFailure,
			analyticsSource,
			backButtonUrl,
			boardId,
			boardType,
			dispatchExternalActionRef,
			ecosystemEnabled,
			estimationStatistic,
			history,
			isLoadedWithPage,
			issueActions,
			issueKey,
			loginRedirectUrl,
			metrics,
			onChange,
			onError,
			applicationKey,
			onIssueKeyChange,
			rapidViewId,
			rapidViewMap,
		}: Props) => React.JSX.Element,
		Props
	>
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazy<typeof ModalIssueAppType>(
		() =>
			import(
				/* webpackChunkName: "async-modal-issue-app" */ '@jira/issue__issue-view/src/IssueModal.tsx'
			),
	);

// Switch between IssueAppSelectorModal (WIV) and ClassicIssueViewModal based on experiment
const IssueViewModalInner = componentWithCondition(
	isWorkItemModernizationGatesEnabled,
	IssueAppSelectorModal,
	ClassicIssueViewModal,
);

export const IssueViewModal = (): React.JSX.Element | null => {
	const [{ isModalOpen, issueKey, onClose, packageName, analyticsSource }] =
		useTriggerIssueViewModal();

	return isModalOpen ? (
		<ModalBoundary packageName={packageName} id="issue-modal">
			<Placeholder name="modal-issue-app" fallback={null}>
				<IssueViewModalInner
					// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
					analyticsSource={analyticsSource}
					issueKey={issueKey}
					onClose={onClose}
				/>
			</Placeholder>
		</ModalBoundary>
	) : null;
};
